import React, { useEffect } from "react";
import Login from "../../../features/auth/login/Login";

const Signin = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-[80vh] flex items-center justify-center">
      <Login />
    </div>
  );
};

export default Signin;
